var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_2633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12.19 3 12.55 3.06 12.77 3.45L21.87 19.22C22.09 19.61 21.97 19.95 21.87 20.11C21.77 20.28 21.55 20.56 21.1 20.56H2.89999C2.44999 20.56 2.21999 20.28 2.12999 20.11C2.02999 19.94 1.90999 19.61 2.12999 19.22L11.23 3.45C11.45 3.06 11.81 3 12 3ZM12 1C11.03 1 10.05 1.48 9.49999 2.45L0.389995 18.21C-0.720005 20.14 0.669995 22.55 2.88999 22.55H21.1C23.33 22.55 24.72 20.14 23.6 18.21L14.5 2.45C13.94 1.49 12.97 1 12 1Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.83 17.88V17.71C10.83 17.34 10.93 17.06 11.14 16.87C11.35 16.68 11.63 16.59 12 16.59C12.37 16.59 12.67 16.68 12.87 16.87C13.07 17.06 13.17 17.34 13.17 17.71V17.88C13.17 18.24 13.07 18.52 12.87 18.71C12.67 18.91 12.38 19 12 19C11.62 19 11.34 18.9 11.14 18.71C10.93 18.52 10.83 18.24 10.83 17.88ZM10.92 14.17V7.64C10.92 7.27 11.01 6.99 11.2 6.79C11.39 6.6 11.65 6.5 12 6.5C12.35 6.5 12.62 6.6 12.81 6.79C13 6.99 13.09 7.27 13.09 7.64V14.17C13.09 14.54 13 14.82 12.81 15.02C12.62 15.21 12.35 15.31 11.99 15.31C11.63 15.31 11.38 15.21 11.19 15.02C11.01 14.83 10.91 14.54 10.91 14.17H10.92Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_2633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/ErrorOutline.203d05ad.svg";
export { ForwardRef as ReactComponent };